const sanitizeHtml = require('sanitize-html');
const _ = require('lodash');

/**
 * Strip any HTML from the supplied string
 * @param str
 * @returns {string}
 */
function stripHtml(str) {
  if (!_.isString(str)) {
    return '';
  }
  return sanitizeHtml(str, {
    allowedTags: [],
    allowedAttributes: {},
    allowedStyles: {},
  });
}

module.exports = stripHtml;
